import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RiArrowDownSLine } from 'react-icons/ri';
import dynamic from 'next/dynamic';
import { InfluencerCloseSVG } from '@/Component/Common/SVGs/CommonSVG';
import CampaignInfo from '@/Component/Brand/MyCampaigns/CampaignDetail/CampaignDetailsTabs/CampaignManagement/CampaignManagementDetail/CampaignInfo';
import QuotationInfo from '@/Component/Brand/MyCampaigns/CampaignDetail/CampaignDetailsTabs/CampaignManagement/CampaignManagementDetail/QuotationInfo';
import DraftInfo from '@/Component/Brand/MyCampaigns/CampaignDetail/CampaignDetailsTabs/CampaignManagement/CampaignManagementDetail/DraftInfo';
import CampaignBrandDetail from './CampaignBrandDetail';
import CampaignManagementDetailSkeleton from '@/Component/Brand/MyCampaigns/CampaignDetail/CampaignDetailsTabs/CampaignManagement/CampaignManagementDetail/CampaignManagementDetailSkeleton';
import PostInfo from './PostInfo';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import { setNotificationDetailState, toggleSavedCampaign } from '@/lib/Features/UserDetailSidebar/userDetailSidebar';
import CampaignOverview from '@/Component/Common/CampaignOverview';
import CampaignOverviewInfluencer from './CampaignOverviewInfluencer';
import BorderButton from '@/Component/Common/Forms/BorderButton';
import usePost from '@/Utils/Hooks/usePost';
import { AddRemoveSavedCampaignAPI, WithdrawFromJobAPI } from '@/Utils/APIRequest/Endpoints';
import { ImageLoaderSVG } from '@/Component/Common/SVGs/AuthSVG';
import { AppStore } from '@/lib/store';
import Cookies from 'js-cookie';
import OtherAttachments from './OtherAttachments';
import Link from 'next/link';
import NeedHelpDropdown from '@/Component/Common/NeedHelpDropdown';
import { CustomToast } from '@/Utils/CustomToast';
import Loader from '@/Layout/Loader';

const CampaignChatInfo = dynamic(() => import("../../../Common/CampaignChatInfo"), {
    ssr: false,
});

const JobDetailSidebar = (props) => {
    const { setOpenSideModal, onCloseSidebar, openSideModal, draftModalOpen, setDraftModalOpen, uploadDraftModalOpen, setUploadDraftModalOpen, JobDetailData, JobDetailDataRefetch, mainListRefetch, fetchStatus, setUploadPost, uploadPost, onRequestUploadPost, setConfirmModalOpen, setApplyModal, setUploadLoader, setDisputeModal, setNeedHelpConfirmModal, needHelpConfirmModal, disputeModal, ref, setIsComponentVisible, setBankModalOpen, translations, mediaUploading, applyModal, setMediaUploading, setAttachmentChoiceType, onRegisterChatUploadHandlers, registerOpenChatAttachment, attachmentChoiceModalOpen, isCometChatReady = true, isFromAdmin } = props;
    const draftUploadTriggerRef = useRef<(() => void) | null>(null);
    const [pendingChatDraftUpload, setPendingChatDraftUpload] = useState(false);
    const dispatch = useDispatch()
    const [status, setStatus] = useState('');
    const [hideStatus, setHideStatus] = useState(false);
    const isSaved = useSelector((state: AppStore) => state.userDetailSidebar.savedCampaigns[JobDetailData?.campaign?.id]) ?? JobDetailData?.campaign?.isCampaignSaved;
    const userDetails: any = useSelector((state: AppStore) => state.userDetailSlice?.userDetails);
    const [otherAttachment, setOtherAttachments] = useState([]);
    // const [activeSection, setActiveSection] = useState<any>(["details", ""]);
    console.log("JobDetailData", JobDetailData);

    useEffect(() => {
        const attachmentData = JobDetailData?.campaign?.campaignInfluencers?.[0]?.attachment || [];
        const chatAttachmentData = JobDetailData?.campaign?.campaignInfluencers?.[0]?.chat_attachment || [];

        // Combine the two arrays if they have data
        const combinedAttachments: any = [...attachmentData, ...chatAttachmentData];

        if (combinedAttachments.length > 0) {
            setOtherAttachments(combinedAttachments);  // Set the combined data
        }
    }, [JobDetailData]);

    const [activeSection, setActiveSection] = useState(() => {
        const collapsedCampaigns = JSON.parse(Cookies.get('collapsed_campaigns') || '{}');
        const isCollapsed = collapsedCampaigns[JobDetailData?.campaign?.id];
        return isCollapsed
            ? ["", status] // "details" (Campaign Info) is collapsed
            : ["details", "", status]; // Expanded by default
    });

    const toggleSection = (section) => {
        const inputEl = document.querySelector('.cometchat-message-composer__input  ');
        if (inputEl instanceof HTMLElement) {
            console.log("blurInput");
            inputEl.blur();
        }
        setActiveSection((prevSections) => {
            const updated = prevSections.includes(section)
                ? prevSections.filter((s) => s !== section)
                : [...prevSections, section];

            if (section === "details" && JobDetailData?.campaign?.id) {
                const campaignId = JobDetailData?.campaign?.id;
                const collapsedCampaigns = JSON.parse(Cookies.get('collapsed_campaigns') || '{}');

                // Update cookie
                if (updated.includes("details")) {
                    delete collapsedCampaigns[campaignId]; // Expanded
                } else {
                    collapsedCampaigns[campaignId] = true; // Collapsed
                }

                Cookies.set('collapsed_campaigns', JSON.stringify(collapsedCampaigns), { expires: 7 });
            }

            return updated;
        });
    };

    const objectEnum = {
        'uncontacted': true,
        'waiting_for_quotations': true,
        'quotation_available': true,
        'completion_request': true,
        'closed': true
    }

    const objectFirstEnum = {
        'uncontacted': true,
        // 'waiting_for_quotations': true
    }

    const applyEnum = {
        'uncontacted': true,
        'waiting_for_quotations': true
    }

    const disputeEnum = {
        'completion_request': true,
        'closed': true
    }

    const deActiveStatusEnum = {
        "uncontacted": true,
        "waiting_for_quotations": true,
        "quotation_available": true
    }

    const registerDraftUploadTrigger = useCallback((fn: () => void) => {
        draftUploadTriggerRef.current = fn;
        if (typeof openSideModal?.setTriggerUploadDraft === 'function') {
            openSideModal.setTriggerUploadDraft(fn);
        }
    }, [openSideModal?.setTriggerUploadDraft]);

    const handleChatUploadDraft = useCallback(() => {
        const ci = JobDetailData?.campaign?.campaignInfluencers?.[0];
        const sectionKey = ci?.influencer_status === 'draft_available' ? 'draft_available' : 'drafting_deliverables';
        setActiveSection((prev) => (prev.includes(sectionKey) ? prev : [...prev, sectionKey]));
        setPendingChatDraftUpload(true);
    }, [JobDetailData?.campaign?.campaignInfluencers]);

    const handleChatUploadPost = useCallback(() => {
        setActiveSection((prev) => (prev.includes('posting_deliverables') ? prev : [...prev, 'posting_deliverables']));
        setTimeout(() => onRequestUploadPost?.(), 150);
    }, [onRequestUploadPost]);

    useEffect(() => {
        if (pendingChatDraftUpload && draftUploadTriggerRef.current) {
            draftUploadTriggerRef.current();
            setPendingChatDraftUpload(false);
        }
    }, [pendingChatDraftUpload, activeSection]);

    useEffect(() => {
        onRegisterChatUploadHandlers?.({
            onUploadDraft: handleChatUploadDraft,
            onUploadPost: handleChatUploadPost,
        });
    }, [onRegisterChatUploadHandlers, handleChatUploadDraft, handleChatUploadPost]);

    const withdrawFromJobStatusEnum = {
        "uncontacted": true,
        "waiting_for_quotations": true,
        "quotation_available": true,
        "closed": true
    }

    const handleDeclareCompletion = () => {
        if (userDetails?.influencerPaymentMethods?.length === 0) {
            setBankModalOpen(true);
            return
        } else {
            setConfirmModalOpen({
                id: JobDetailData?.campaign?.campaignInfluencers?.[0]?.id,
                JobDetailDataRefetch: JobDetailDataRefetch,
                offline_payment: JobDetailData?.brandDetails?.offline_payment_allowed,
                influencer_budget: JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_budget
            });
        }
    }

    useEffect(() => {
        if (JobDetailData?.campaign?.campaignInfluencers.length > 0) {
            let shownStatus = JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_status?.replace("_", " ");
            setStatus(shownStatus);
            let jobStatus = (JobDetailData?.campaign?.campaignInfluencers?.[0]?.status == JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_status) ? JobDetailData?.campaign?.campaignInfluencers?.[0]?.status : JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_status
            let activeStatus = jobStatus;
            setActiveSection((prevSections) =>
                prevSections.includes(activeStatus) ? prevSections.filter((s) => s !== activeStatus) : [...prevSections, activeStatus]
            );
        }
    }, [JobDetailData]);

    const shownStatusEnum = {
        "uncontacted": translations?.unContacted,
        "waiting for_quotations": translations?.waitingForQuotations,
        "quotation available": translations?.quotationAvailable,
        "drafting deliverables": translations?.draftDeliverables,
        "draft available": translations?.draftAvailable,
        "posting deliverables": translations?.postingDeliverables,
        "completion request": translations?.completionRequest,
        "closed": translations?.closed
    }

    // const toggleSection = (section) => {
    //     setActiveSection((prevSections) =>
    //         prevSections.includes(section) ? prevSections.filter((s) => s !== section) : [...prevSections, section]
    //     );
    // };

    const handleQuickApply = () => {
        setApplyModal(JobDetailData?.campaign);
    }

    // Need Help - Influencer: always available; "Brand unfairly rejected work" when status is completion_request or closed (after declaring completion & brand rejected)
    const influencerNeedHelpStatuses = ['completion_request', 'closed'];
    const showInfluencerNeedHelp = userDetails?.role === 'influencer' && JobDetailData?.campaign?.status === 'running' && JobDetailData?.campaign?.campaignInfluencers?.length > 0;
    const ci = JobDetailData?.campaign?.campaignInfluencers?.[0];
    const influencerCampaignId = ci?.id;
    const { mutate: withdrawMutate } = usePost(`${WithdrawFromJobAPI}/${influencerCampaignId}`, null, () => {
        CustomToast("success", translations?.withdrawFromJobSuccessfully ?? 'Withdraw from job successfully');
        JobDetailDataRefetch?.();
        mainListRefetch?.();
        setOpenSideModal(null);
        onCloseSidebar?.();
    }, 'patch');

    const handleWithdrawFromJob = () => {
        if (!influencerCampaignId) return;
        withdrawMutate();
    }
    const canInfluencerRaiseDispute = disputeEnum[ci?.influencer_status] && !ci?.dispute?.is_influencer_despute;
    const raiseDisputeOption = {
        id: 'raise_dispute',
        label: translations?.raiseDispute ?? 'Raise Dispute',
        onClick: () => setDisputeModal({ ...JobDetailData, disputeReason: 'Dispute' })
    };
    const primaryNeedHelpOptions =
        ci?.rejectCompletionRequest?.length > 0
            ? [
                {
                    id: 'brand_unfairly_rejected',
                    label: translations?.brandUnfairlyRejectedWorkOption ?? 'Brand unfairly rejected work',
                    onClick: () => setNeedHelpConfirmModal({
                        type: 'escalate_dispute',
                        onConfirm: () => setDisputeModal({ ...JobDetailData, disputeReason: 'Brand unfairly rejected work' })
                    })
                },
                ...(canInfluencerRaiseDispute ? [raiseDisputeOption] : [])
            ]
            : canInfluencerRaiseDispute
                ? [raiseDisputeOption]
                : [];

    const withdrawFromJobOption = {
        id: 'withdraw_from_job',
        label: translations?.withdrawFromJobLabel ?? 'Withdraw from job',
        onClick: () =>
            setNeedHelpConfirmModal({
                type: 'withdraw_from_job',
                onWithdrawFromJob: () => handleWithdrawFromJob()
            })
    };

    // Withdraw is hidden only for deActiveStatusEnum; all other statuses include it (alongside dispute / escalation when applicable).
    const influencerNeedHelpOptions = withdrawFromJobStatusEnum[ci?.status]
        ? primaryNeedHelpOptions
        : [...primaryNeedHelpOptions, withdrawFromJobOption];

    const clickOut = () => {
        setIsComponentVisible((prev) => false)
        setOpenSideModal(null)
        setUploadPost(null)
        setAttachmentChoiceType(null)
        dispatch(setNotificationDetailState(null))
        onCloseSidebar?.()
    }

    const { isPending, mutate } = usePost(AddRemoveSavedCampaignAPI, null, (response) => {
        if (response?.status == 200 || response?.status == 201) {
        } else {
            dispatch(toggleSavedCampaign({ campaignId: JobDetailData?.campaign?.id, value: !isSaved }));
        }
    }, null);

    const handleToggle = () => {
        dispatch(toggleSavedCampaign({ campaignId: JobDetailData?.campaign?.id, value: !isSaved }));
        let obj: any = {
            campaign_id: JobDetailData?.campaign?.id
        }
        mutate(obj)
    }

    if (fetchStatus === "fetching") return <CampaignManagementDetailSkeleton />

    return (
        <>
            <div className="flex sm:items-center justify-between max-sm:flex-col max-sm:gap-3 fixed top-0 lg:py-5 py-3 bg-white z-50 left-0 right-0 lg:px-6 px-4 w-full">
                <div className="flex items-center lg:gap-10 md:gap-5 gap-2.5">
                    <div className="text-black font-bold z-10 cursor-pointer" onClick={clickOut}><InfluencerCloseSVG /></div>
                    <div className='max-md:text-xs text-sm'><span>{JobDetailData?.campaign?.campaign_name}</span> {status && `/`} <span className="font-semibold capitalize">{shownStatusEnum[status]}</span></div>
                </div>
                <div className="flex gap-1.5 items-center justify-between max-sm:self-end">
                    {JobDetailData?.campaign?.status == 'running' && !isFromAdmin &&
                        <>
                            {deActiveStatusEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.status] && <BorderButton buttonType="button" customClass="!py-1.5 flex items-center gap-1.5" onClick={handleToggle} disabled={isPending} >
                                {isSaved == 1 ? translations?.saved : translations?.save}
                                {isPending && <ImageLoaderSVG />}
                            </BorderButton>
                            }

                            {((JobDetailData?.campaign?.campaignInfluencers?.length == 0) || (applyEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.status])) &&
                                <PrimaryButton buttonType="button" customClass="!py-1.5" onClick={handleQuickApply} >{translations?.easyApply}</PrimaryButton>
                            }

                            {/* {(JobDetailData?.campaign?.campaignInfluencers?.length > 0 && disputeEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_status] && !JobDetailData?.campaign?.campaignInfluencers?.[0]?.dispute?.is_influencer_despute) &&
                                <span className="cursor-pointer mr-3" onClick={handleDispute}>{translations?.raiseDispute}</span>
                            } */}

                            {(JobDetailData?.campaign?.campaignInfluencers?.length > 0 && !objectEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.status]) &&
                                <PrimaryButton buttonType="button" customClass="!h-auto !py-2 !border-closed !bg-closed max-sm:whitespace-nowrap" onClick={handleDeclareCompletion} >{translations?.declareCompletion}</PrimaryButton>
                            }

                            {showInfluencerNeedHelp && <NeedHelpDropdown options={influencerNeedHelpOptions} helpGuideUrl="https://www.connector.cc/faq-creator" helpGuideLabel={translations?.checkHelpGuides ?? 'Check Help Guides'} buttonLabel={translations?.needHelp ?? 'Need Help?'} customClass="max-sm:ml-auto" />}
                        </>
                    }
                </div>
            </div>
            {JobDetailData?.campaign?.campaignInfluencers?.[0]?.dispute?.status == 'unsolved' &&
                <div className="bg-red-500/25 rounded-md px-5 py-2 mb-3 flex items-center justify-center text-center">
                    {translations?.disputeMessage}
                </div>
            }
            <div className="grid grid-cols-12 gap-2.5">
                <div className="col-span-12 2xl:col-span-6 lg:col-span-7">
                    {(JobDetailData?.campaign?.campaignInfluencers?.length > 0 && !objectFirstEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.status]) ?
                        <>
                            {/* Campaign Information */}
                            <div className={`border border-lightGray p-4 rounded-xl mb-2.5`} >
                                <div className="flex items-center justify-between cursor-pointer" onClick={() => toggleSection("details")}>
                                    <div className={`font-semibold ${activeSection.includes("details") ? "text-primary" : ""}`}>
                                        {translations?.campaignInformation}
                                    </div>
                                    <div className={`min-w-5 h-5  rounded-full flex items-center justify-center transition-all ${activeSection.includes("details") ? "rotate-180 bg-gradient-to-br from-secondary to-primary" : "bg-darkGray"}`}>
                                        <RiArrowDownSLine className="text-white" />
                                    </div>
                                </div>
                                {activeSection.includes("details") && (
                                    <CampaignInfo campaignInfoData={JobDetailData?.campaign} translations={translations} campaignDraftDate={JobDetailData?.campaign?.campaignInfluencers?.[0]?.draft_due_date} campaignPostDate={JobDetailData?.campaign?.campaignInfluencers?.[0]?.post_due_date} campaignInfluencerId={JobDetailData?.campaign?.campaignInfluencers?.[0]?.id} status={status} />
                                )}
                            </div>

                            {/* Quotation Dropdown */}
                            <div className={`border border-lightGray rounded-xl mb-2.5 ${(JobDetailData?.campaign?.campaignInfluencers?.[0]?.status === "waiting_for_quotations" ? "pointer-events-none opacity-50" : "")}`} >
                                <div className="flex items-center justify-between cursor-pointer p-4" onClick={() => toggleSection("quotation_available")}>
                                    <div className={`font-semibold ${activeSection.includes("quotation_available") ? "text-primary" : ""}`}>
                                        {translations?.quotation}
                                    </div>
                                    <div className={`min-w-5 h-5  rounded-full flex items-center justify-center transition-all ${activeSection.includes("quotation_available") ? "rotate-180 bg-gradient-to-br from-secondary to-primary" : "bg-darkGray"}`}>
                                        <RiArrowDownSLine className="text-white" />
                                    </div>
                                </div>
                                {activeSection.includes("quotation_available") && (
                                    <QuotationInfo quotationInfo={JobDetailData} setApplyModal={setApplyModal} translations={translations} ManagementDetailDataRefetch={JobDetailDataRefetch} />
                                )}
                            </div>

                            {/* Draft Dropdown */}
                            <div className={`border border-lightGray rounded-xl p-4 mb-2.5 ${(JobDetailData?.campaign?.campaignInfluencers?.[0]?.status === "quotation_available" || JobDetailData?.campaign?.campaignInfluencers?.[0]?.status === "waiting_for_quotations") ? "pointer-events-none opacity-50" : ""}`} >
                                <div className={`flex items-center justify-between cursor-pointer`} onClick={() => toggleSection("drafting_deliverables")}>
                                    <div className={`font-semibold ${(activeSection.includes("drafting_deliverables") || activeSection.includes("draft_available")) ? "text-primary" : ""}`}>
                                        {translations?.draft}
                                    </div>
                                    <div className={`min-w-5 h-5  rounded-full flex items-center justify-center transition-all ${(activeSection.includes("drafting_deliverables") || activeSection.includes("draft_available")) ? "rotate-180 bg-gradient-to-br from-secondary to-primary" : "bg-darkGray"}`}>
                                        <RiArrowDownSLine className="text-white" />
                                    </div>
                                </div>
                                {(activeSection.includes("drafting_deliverables") || activeSection.includes("draft_available")) && (
                                    <DraftInfo draftInfoData={JobDetailData?.campaign?.campaignInfluencers?.[0]} draftModalOpen={draftModalOpen} setDraftModalOpen={setDraftModalOpen} uploadDraftModalOpen={uploadDraftModalOpen} setUploadDraftModalOpen={setUploadDraftModalOpen} JobDetailDataRefetch={JobDetailDataRefetch} setUploadLoader={setUploadLoader} JobDetailData={JobDetailData?.campaign} translations={translations} registerUploadTriggerRef={registerDraftUploadTrigger} />
                                )}
                            </div>

                            {/* Post Dropdown */}
                            <div className={`border border-lightGray rounded-xl p-4 mb-2.5 ${(() => {
                                const ci = JobDetailData?.campaign?.campaignInfluencers?.[0];
                                const hasApprovedDraft = ci?.drafts?.some((d: any) => d?.status === 'approved') ?? false;
                                const isDisabled =
                                    ci?.influencer_status === "quotation_available" ||
                                    ci?.influencer_status === "waiting_for_quotations" ||
                                    (ci?.influencer_status === "drafting_deliverables" && (ci?.drafts?.length ?? 0) > 0 && (ci?.posts?.length ?? 0) === 0 && !hasApprovedDraft) ||
                                    (ci?.influencer_status === "draft_available" && (ci?.posts?.length ?? 0) === 0 && !hasApprovedDraft);
                                return isDisabled ? "pointer-events-none opacity-50" : "";
                            })()}`} >
                                <div className={`flex items-center justify-between cursor-pointer`} onClick={() => toggleSection("posting_deliverables")}>
                                    <div className={`font-semibold ${(activeSection.includes("posting_deliverables")) ? "text-primary" : ""}`}>
                                        {translations?.post}
                                    </div>
                                    <div className={`min-w-5 h-5  rounded-full flex items-center justify-center transition-all ${(activeSection.includes("posting_deliverables")) ? "rotate-180 bg-gradient-to-br from-secondary to-primary" : "bg-darkGray"}`}>
                                        <RiArrowDownSLine className="text-white" />
                                    </div>
                                </div>
                                {(activeSection.includes("posting_deliverables")) && (
                                    <PostInfo postInfoData={JobDetailData?.campaign?.campaignInfluencers?.[0]} setUploadPost={setUploadPost} onRequestUploadPost={onRequestUploadPost} uploadPost={uploadPost} JobDetailData={JobDetailData?.campaign} translations={translations} registerUploadTriggerRef={openSideModal?.setTriggerUploadPost} />
                                )}
                            </div>

                            {/* Other Attachments */}
                            {(JobDetailData?.campaign?.campaignInfluencers?.[0]?.attachment?.length > 0 || JobDetailData?.campaign?.campaignInfluencers?.[0]?.chat_attachment?.length > 0) && (
                                <div className={`border border-lightGray rounded-xl p-4 mb-2.5`} >
                                    <div className={`flex items-center justify-between cursor-pointer`} onClick={() => toggleSection("other_attachments")}>
                                        <div className={`font-semibold ${activeSection.includes("other_attachments") ? "text-primary" : ""}`}>
                                            {translations?.otherAttachments}
                                        </div>
                                        <div className={`min-w-5 h-5  rounded-full flex items-center justify-center transition-all ${activeSection.includes("other_attachments") ? "rotate-180 bg-gradient-to-br from-secondary to-primary" : "bg-darkGray"}`}>
                                            <RiArrowDownSLine className="text-white" />
                                        </div>
                                    </div>
                                    {activeSection.includes("other_attachments") && (
                                        <OtherAttachments userDetails={userDetails} attachmentData={otherAttachment} setOtherAttachments={setOtherAttachments} />
                                    )}
                                </div>
                            )}

                            {/* Chat */}
                            <div className="md:py-4 md:px-5 md:bg-gray/10 rounded-lg max-md:mt-5">
                                <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                                    <div className={`font-semibold text-sm`}>
                                        {translations?.chat}
                                    </div>
                                    <div className="flex items-center gap-2 flex-wrap text-xs">

                                        {translations?.hideStatus}
                                        <label className='relative inline-flex items-center'>
                                            <input
                                                type='checkbox'
                                                onChange={() => setHideStatus(!hideStatus)}
                                                className='sr-only peer disabled:pointer-events-none'
                                            />
                                            <div className="w-6 h-4 bg-white border cursor-pointer border-black rounded-full peer-checked:bg-gradient-to-br from-secondary to-primary peer-checked:border-transparent peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-1 after:left-1 after:bg-black after:rounded-full after:h-2 after:w-2 after:transition-all peer-checked:after:bg-white peer-disabled:pointer-events-none"></div>
                                        </label>
                                    </div>
                                </div>
                                {(JobDetailData?.campaign?.is_active == false && deActiveStatusEnum[JobDetailData?.campaign?.campaignInfluencers?.[0]?.influencer_status]) ?
                                    <div className="h-80 flex items-center justify-center flex-col gap-3">
                                        <p className='text-center text-md max-w-sm'>
                                            {translations?.thisCampaignIsCurrentlyRestricted}<br /> {translations?.pleaseTryAgainLater}
                                        </p>
                                    </div> :
                                    isCometChatReady ? (
                                        <CampaignChatInfo ManagementDetailData={JobDetailData} hideStatus={hideStatus} mediaUploading={mediaUploading} setMediaUploading={setMediaUploading} setOtherAttachments={setOtherAttachments} setApplyModal={setApplyModal} applyModal={applyModal} uploadDraftModalOpen={uploadDraftModalOpen} draftModalOpen={draftModalOpen} disputeModal={disputeModal} translations={translations} setAttachmentChoiceType={setAttachmentChoiceType} registerOpenChatAttachment={registerOpenChatAttachment} attachmentChoiceModalOpen={attachmentChoiceModalOpen} MainListRefetch={mainListRefetch} />
                                    ) : (
                                        <div className="h-80 flex items-center justify-center">
                                            <Loader />
                                        </div>
                                    )
                                }
                            </div>
                        </>
                        :
                        <CampaignOverviewInfluencer data={JobDetailData?.campaign} translations={translations} />
                    }
                </div>
                <div className="col-span-12 2xl:col-span-6 lg:col-span-5">
                    <CampaignBrandDetail campaignBrandDetailData={JobDetailData?.brandDetails} />
                </div>
            </div>
        </>
    )
}

export default JobDetailSidebar
